import formStyle from '../style/WForm.less';
import classNames from 'classnames';
import { getAdditionalInfo } from '../helpers/getAdditionalInfo';
import { getAdditionalUnit } from '../helpers/getAdditionalUnit';
import * as React from 'react';
import { toFixedDecimal, formatNumber } from '../../formatter/formatNumber';
import { getKomplexRowClassname } from '../../../main/functions/getFormKey';

interface WFormFieldNumberProps extends React.ClassAttributes<any> {
    id?: string;
    data: any;
    label: JSX.Element;
    name: string;
    entity: string;
    value: string;
    row: any;
    required?: boolean;
    readonly?: boolean;
    disabled?: boolean;
    showMode?: boolean;
    hidden_input?: boolean;
    layout?: string;
    customStyle?: any;
    decimals?: number;
    maxLength?: number;
    placeholder?: string;
    hidden_msg?: string;
    errorLevelKey?: string;
    custom_component?: (setValue?: (value: string) => void) => JSX.Element;
    onValueChange(name: string, value: any): void;
}

interface WFormFieldNumberState {
    isFocused: boolean;
}

export class WFormFieldNumber extends React.Component<WFormFieldNumberProps, WFormFieldNumberState> {

    constructor(props: any) {
        super(props);
        this.onInputChange = this.onInputChange.bind(this);
        this.setValue = this.setValue.bind(this);
        this.state = {
            isFocused: false
        };
    }

    onInputChange(event: any) {
        let value = event.target.value;
        if (value === '') {
            // console.log('Change Num = empty');
            this.props.onValueChange(this.props.name, value);
        } else {
            // console.log('Change Num 1', value);
            if ((value + '').indexOf(',') > -1) {
                value = value.replace('.', '').replace(',', '.');
                console.log('Change Num 1a', value);
            }
            const value_check = +(value + '' + 0);
            const val = (value === undefined || value === '' || isNaN(+value_check)) ? null : toFixedDecimal(value, this.props.decimals);
            // console.log('Change Num 2', this.props.name, val);
            if (val !== null) {
                this.props.onValueChange(this.props.name, val);
            }
        }
    }

    render() {
        const { layout, customStyle, maxLength, placeholder, custom_component, id, showMode, hidden_input, hidden_msg, readonly, decimals, errorLevelKey } = this.props;
        const disabled: boolean = this.props.readonly || this.props.disabled ? true : false;
        const styleDisabled: any = disabled ? { backgroundColor: 'var(--color-wform-field-bg-disabled)' } : {};
        if (hidden_input) {
            styleDisabled.display = 'none';
        }
        const customStyleClassInput = customStyle && customStyle.classInput ? customStyle.classInput : {};
        const customStyleInput = customStyle && customStyle.input ? customStyle.input : {};
        const value = this.props.value;
        // console.log(this.props.name, value);
        const additionalInfo = getAdditionalInfo(this.props.entity, this.props.name);
        const additionalUnit = getAdditionalUnit(this.props.entity, this.props.name, this.props.row, this.props.data);
        const style = {
            display: 'flex', flexDirection: 'row',
            ...((layout === 'sidebysideComplex' || layout === 'sidebysideComplexGreen') ? { alignItems: 'center' } : { alignItems: 'flex-end', position: 'relative' }),
            ...((layout === 'flowV2') ? { alignItems: 'center' } : {}),
            ...customStyleClassInput
        };
        const errInputStyle = typeof errorLevelKey === 'string' && errorLevelKey === 'error' ? formStyle.errorlevel_default : null;
        const that = this;
        const krCls = getKomplexRowClassname((this.props.row || {})._formKey, this.props.name) || undefined;

        if (showMode) {
            let showVal = value === null || value === undefined || value === '' ? (placeholder || '') : +value;
            showVal = typeof showVal === 'number' ? formatNumber(showVal, decimals >= 0 ? decimals : 2) : showVal;
            return (
                <div className={classNames(formStyle.fieldBox, krCls)}>
                    {this.props.label}
                    <div className={classNames(formStyle.input, formStyle.showMode, errInputStyle)}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', overflow: 'hidden' }}>
                            {hidden_input ? '' : showVal}
                            {!hidden_input && showVal ? additionalUnit : null}
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className={classNames(formStyle.fieldBox, krCls)}>
                {this.props.label}
                <div
                    className={classNames(formStyle.input)}
                    style={style}
                >
                    <input
                        id={id}
                        style={{ ...styleDisabled, ...customStyleInput }}
                        className={classNames(formStyle.inputText, errInputStyle)}
                        name={this.props.name}
                        value={(value === undefined || value === null || isNaN(+(value + '0'))) ? '' : ((value + '').replace('.', ','))}
                        readOnly={disabled}
                        onChange={this.onInputChange}
                        maxLength={maxLength > 0 ? maxLength : 999}
                        placeholder={(readonly && hidden_msg)
                            ? hidden_msg
                            : (placeholder
                                ? (placeholder === undefined || placeholder === null || isNaN(+(placeholder + '0'))) ? '' : ((placeholder + '').replace('.', ','))
                                : (maxLength > 0 ? ` max. ${maxLength} Zahlen` : '')
                            )
                        }
                        onFocus={() => that.setState({ isFocused: true })}
                        onBlur={() =>
                            // Set Timeout, damit Links im Hinweis geklickt werden können
                            window.setTimeout(() => that.setState({ isFocused: false }), 250)
                        }
                        autoComplete='off'
                    />
                    {!hidden_input && additionalUnit}
                    {(additionalInfo && this.state.isFocused) && <div
                        style={{
                            position: 'absolute',
                            top: (layout === 'sidebysideComplex' || layout === 'sidebysideComplexGreen') ? 25 : 40,
                            width: (layout === 'sidebysideComplex' || layout === 'sidebysideComplexGreen') ? 300 : 453,
                            fontSize: 11,
                            borderRadius: 5,
                            zIndex: 10000,
                            backgroundColor: 'rgba(255, 255, 200, 0.9)',
                            padding: 8,
                            border: '1px solid #aaa'
                        }}>
                        {additionalInfo}
                    </div>}
                    {(hidden_input && hidden_msg) &&
                        <i style={{ paddingTop: 5, color: '#666' }}>&nbsp;{hidden_msg}</i>
                    }
                    {typeof custom_component === 'function' &&
                        <div style={{ flex: 1 }}>{custom_component(this.setValue)}</div>
                    }
                </div>
            </div>
        );
    }

    setValue(value: string) {
        this.props.onValueChange(this.props.name, value);
    }
}
